import { isDayjs } from 'dayjs';
import { IFormData } from '.';

export const serializeAndValidateFormData = (formData: IFormData) => {
  const serializedFormData = { ...formData };
  if (isDayjs(serializedFormData.invoiceDate)) {
    serializedFormData.invoiceDate = serializedFormData.invoiceDate.format('YYYY-MM-DD');
  }

  if (isDayjs(serializedFormData.dueDate)) {
    serializedFormData.dueDate = serializedFormData.dueDate.format('YYYY-MM-DD');
  }

  return { formData: serializedFormData, isValid: true, errorMsg: '' };
};
